import PerfectScrollbar from 'vue2-perfect-scrollbar';
import Paginate from 'vuejs-paginate';
import VCalendar from 'v-calendar';
import Vuescroll from 'vue-scroll';
import TextareaAutosize from 'vue-textarea-autosize';
import VueSlider from 'vue-slider-component';
import SlideUpDown from 'vue-slide-up-down';
import VueTimepicker from 'vue2-timepicker';
import 'vue-slider-component/theme/default.css';
import 'vue2-timepicker/dist/VueTimepicker.css';
import 'leaflet/dist/leaflet.css';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import { Icon } from 'leaflet';
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vClickOutside from 'v-click-outside'
import Transitions from 'vue2-transitions'
export default (app) => {
  app.use(Transitions)
  app.component("ValidationProvider", ValidationProvider);
  app.component("ValidationObserver", ValidationObserver);
  app.use(PerfectScrollbar, {
    handlers: ['wheel', 'click-rail', 'drag-thumb', 'keyboard', 'touch'],
    options: {
      wheelPropagation: false,
      useBothWheelAxes: false,
    },
  });
  app.use(VCalendar, {
    componentPrefix: 'vc',
  });
  app.use(Vuescroll);
  app.use(TextareaAutosize);
  app.use(VueAwesomeSwiper);
  app.component('slide-up-down', SlideUpDown);
  app.component('VueSlider', VueSlider);
  app.component('VueTimepicker', VueTimepicker);
  app.component('paginate', Paginate);
  delete Icon.Default.prototype._getIconUrl;
  Icon.Default.mergeOptions({
    iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
    iconUrl: require('leaflet/dist/images/marker-icon.png'),
    shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
  });
  app.use(vClickOutside)
}